import { render, staticRenderFns } from "./TheReminders.vue?vue&type=template&id=81ca818c"
import script from "./TheReminders.vue?vue&type=script&lang=js"
export * from "./TheReminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81ca818c')) {
      api.createRecord('81ca818c', component.options)
    } else {
      api.reload('81ca818c', component.options)
    }
    module.hot.accept("./TheReminders.vue?vue&type=template&id=81ca818c", function () {
      api.rerender('81ca818c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/layout/TheReminders.vue"
export default component.exports